import { TextAttachDTO } from '@fontanka/news-api-client';
import { TextAttach } from '../../../domain';

export const createTextAttach = (attach: TextAttachDTO): TextAttach => ({
  type: 'text',
  value: attach.value.text
});
